import React, { useState, useEffect } from 'react';

const Advertisement = () => {
    const [currentAd, setCurrentAd] = useState(0);
    const [visible, setVisible] = useState(true);

    // Advertisement data
    const ads = [
        {
            id: 2,
            title: "📚 New Study Materials Added!",
            description: "Check out our latest study materials for Bihar SI and BPSC exams.",
            bgColor: "from-blue-500 to-indigo-500",
            icon: "📖",
            link: "/university-study-material",
            linkText: "Explore Now →"
        },
        {
            id: 3,
            title: "🏆 Mock Test Series 2024",
            description: "Practice with our updated mock test series. Real exam pattern!",
            bgColor: "from-purple-500 to-pink-500",
            icon: "🏆",
            link: "/mock-tests-new",
            linkText: "Start Practicing →"
        }
    ];

    // Auto-rotate ads every 5 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentAd((prev) => (prev + 1) % ads.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [ads.length]);

    const handleClose = () => {
        setVisible(false);
    };

    if (!visible) {
        return null;
    }

    const ad = ads[currentAd];

    return (
        <div className={`relative overflow-hidden bg-gradient-to-r ${ad.bgColor} text-white`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 md:py-4">
                <div className="flex items-center justify-between flex-wrap gap-3">
                    <div className="flex items-center gap-3 flex-1 min-w-0">
                        <div className="text-2xl md:text-3xl animate-bounce">
                            {ad.icon}
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-sm md:text-base font-bold truncate">
                                {ad.title}
                            </p>
                            <p className="text-xs md:text-sm opacity-90 truncate">
                                {ad.description}
                            </p>
                        </div>
                        <a
                            href={ad.link}
                            className="flex-shrink-0 text-xs md:text-sm font-semibold bg-white/20 hover:bg-white/30 px-3 py-1.5 md:px-4 md:py-2 rounded-lg transition-all duration-200 whitespace-nowrap"
                        >
                            {ad.linkText}
                        </a>
                    </div>
                    <button
                        onClick={handleClose}
                        className="flex-shrink-0 text-white/70 hover:text-white transition-colors p-1"
                        aria-label="Close advertisement"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>

            {/* Progress bar */}
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-white/30">
                <div
                    className="h-full bg-white/60 rounded-full transition-all duration-100 ease-linear"
                    style={{ width: '100%' }}
                />
            </div>
        </div>
    );
};

export default Advertisement;